<script setup>
defineProps({
  width: {
    type: Number,
    default: 16,
  },
  height: {
    type: Number,
    default: 16,
  },
});
</script>

<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.0537 12.6445C7.78449 12.6445 6.75195 13.6771 6.75195 14.9463V20.6982C6.75195 21.9674 7.78449 23 9.0537 23C10.3229 23 11.3555 21.9675 11.3555 20.6982V14.9463C11.3555 13.6771 10.3229 12.6445 9.0537 12.6445Z"
      fill="#8C8C8C"
    />
    <path
      d="M5.46282 12.6445H3.23446C2.00573 12.6445 1.0061 13.6442 1.0061 14.8729C1.0061 16.1016 2.00577 17.1013 3.23446 17.1013C4.46315 17.1013 5.46282 16.1016 5.46282 14.8729V12.6445Z"
      fill="#8C8C8C"
    />
    <path
      d="M1 9.05374C1 10.323 2.03254 11.3555 3.30175 11.3555H9.05368C10.3229 11.3555 11.3555 10.323 11.3555 9.05374C11.3555 7.78453 10.3229 6.75199 9.05372 6.75199H3.30175C2.03254 6.75195 1 7.78453 1 9.05374Z"
      fill="#8C8C8C"
    />
    <path
      d="M9.12729 5.46287H11.3556V3.23451C11.3556 2.00577 10.356 1.00615 9.12729 1.00615C7.89855 1.00615 6.89893 2.00582 6.89893 3.23451C6.89893 4.4632 7.89855 5.46287 9.12729 5.46287Z"
      fill="#8C8C8C"
    />
    <path
      d="M14.9463 11.3555C16.2155 11.3555 17.248 10.3229 17.248 9.05372V3.30175C17.2481 2.03254 16.2155 1 14.9463 1C13.6771 1 12.6445 2.03254 12.6445 3.30175V9.05368C12.6445 10.3229 13.6771 11.3555 14.9463 11.3555Z"
      fill="#8C8C8C"
    />
    <path
      d="M18.5371 11.3555H20.7655C21.9942 11.3555 22.9938 10.3558 22.9938 9.1271C22.9938 7.89837 21.9942 6.89874 20.7655 6.89874C19.5368 6.89874 18.5371 7.89841 18.5371 9.1271V11.3555Z"
      fill="#8C8C8C"
    />
    <path
      d="M23 14.9463C23 13.6771 21.9675 12.6445 20.6982 12.6445H14.9463C13.6771 12.6445 12.6445 13.6771 12.6445 14.9463C12.6445 16.2155 13.6771 17.248 14.9463 17.248H20.6982C21.9675 17.2481 23 16.2155 23 14.9463Z"
      fill="#8C8C8C"
    />
    <path
      d="M14.8729 18.5371H12.6445V20.7655C12.6445 21.9942 13.6442 22.9938 14.8729 22.9938C16.1016 22.9938 17.1013 21.9942 17.1013 20.7655C17.1013 19.5368 16.1016 18.5371 14.8729 18.5371Z"
      fill="#8C8C8C"
    />
  </svg>
</template>
